export default __webpack_public_path__ + "static/media/598.d4a73313.jpg";